import {observer} from "mobx-react"
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Table} from "semantic-ui-react"
import Price from "components/Price/Price"
import _ from "lodash"
import { Link } from "react-router-dom"
import shop from "shop/shop"

@observer
export default class ProductTableReadOnly extends Component {
	static propTypes = {
		list    : PropTypes.object,
		cart    : PropTypes.object,
		onChange: PropTypes.func,
		products: PropTypes.array,
		minimal : PropTypes.bool
	}

	constructor() {
		super()
	}

	render() {
		let {list, cart, products, onChange, minimal, showTax} = this.props
		let positions = list || products
		if ( list ) positions = list.products
		let rows = _.map( positions, ( product, index ) => {
			return (
				<ProductRow showTax={showTax} minimal={minimal} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product} />
			)
		} )
		return (
			<Table>
				<colgroup>
					<col width="" />
					<col width="70%" />
					<col width="" />
					<col width="5%" />
				</colgroup>
				<thead>
				<tr>
				
				<th>&nbsp;</th>
				<th>Artikel</th>
					{/*{!minimal && <th>{translate("Preis/VE")}</th>}*/}
					{/*<th>{translate( "VE" )}</th>*/}
					<th>{translate( "VE" )}</th>
					<th>{translate( "Menge" )}</th>
					{showTax && <th>{translate( "Steuer" )}</th>}
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <th className="tr">
						<div className="tr">{translate( "Summe" )}</div>
					</th>}

				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</Table>
		)
	}
}

const ProductRow = ( {product, minimal, showTax} ) => {
	return (
		<tr>
			<td>
				<Link to={`/product/${product.map_id}`}>
					<img
						className="db center"
						height="34"
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
			<td>
				<strong>{product.article_nr}</strong>
				<div><span className="product-title"><span className="nowrap">{product.title}</span></span></div>
			</td>
			{/*{!minimal && <td><Price>{product.price}</Price></td>}*/}
			<td>
				<div className={"nowrap"}>{product.unit_multi} {translate( "Stück" )}</div>
			</td>
			<td>
			<div className={"nowrap"}>{product.count} {translate( "VE" )}</div>
			</td>
		
			{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <td>
		<div className="tr">
		{product.pinfos && product.pinfos.brutto && <div><span className="strike black-60"><Price>{product.pinfos.brutto * product.count * product.unit_multi}</Price></span></div>}
		{product.pinfos && product.pinfos.brutto && <div><span className="red fw6 pb2 tr"><Price>{product.price * product.count * product.unit_multi}</Price></span></div>}
		{product.pinfos && !product.pinfos.brutto &&  <div><Price>{product.price * product.count * product.unit_multi}</Price></div>}
		</div>
	  </td>}
		</tr>
	)
}

ProductRow.propTypes = {
	index   : PropTypes.any,
	list    : PropTypes.object,
	cart    : PropTypes.object,
	onChange: PropTypes.func,
	product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/braunco/components/Product/ProductTableReadOnly.js